<template>
  <div v-if="thirdPartyTagsData">
    <fresh-chat-widget v-if="thirdPartyTagsData.freshchat"></fresh-chat-widget>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import FreshChatWidget from '@/components/FreshChatWidget';

export default {
  name: 'ContactSupport',

  components: {
    FreshChatWidget,
  },

  computed: {
    ...mapGetters(['userProfile']),

    thirdPartyTagsData() {
      return this.userProfile ? this.userProfile.third_party_tags_data : null;
    },
  },
};
</script>
